import * as React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { Typography, ButtonBase, makeStyles } from '@material-ui/core';
import { datestamp } from '../../../youwell-common/dateUtils';
import { AddForm, VimoModal } from '../../../common/components';
import * as PatientStore from '../../../app/store/PatientStore';

const useStyles = makeStyles(theme => ({
    root: {
    },
    item: {
        marginBottom: theme.spacing(1),
        display: 'flex',
        textAlign: 'left',
        width: '100%',
    },
    itemText: {
        flex: '1 1 auto',
    },
    underline: {
        borderBottom: '1px solid',
    },
}));

const FormList = ({
    studentId, patientProgramId,
}) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const translate = useSelector(state => getTranslate(state.localize));
    const formElements = useSelector(state => state.patient.details && state.patient.details[studentId]?.therapistTasks);
    const [selectedElement, setSelectedElement] = React.useState(null);

    React.useEffect(() => {
        if (!formElements) {
            dispatch(PatientStore.actionCreators.getTherapistTasks({
                requestParams: {
                    patientId: studentId,
                },
                reducerParams: {
                    patientId: studentId,
                },
            }));
        }
    }, [dispatch, formElements, studentId]);

    if (!formElements?.length) {
        return (
            <Typography color="textSecondary">
                {translate('student.noFormsAssigned')}
            </Typography>
        );
    }


    return (
        <div className={classes.root}>
            {formElements.map(item => (
                <ButtonBase className={classes.item} key={item.id} onClick={() => setSelectedElement(item)}>
                    <Typography className={classes.itemText}>
                        <span className={classes.underline}>
                            {item.task?.name}
                        </span>
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                        {datestamp(item.latestResponse || item.completedDate)}
                    </Typography>
                </ButtonBase>
            ))}

            <VimoModal
                open={!!selectedElement}
                onClose={() => setSelectedElement(null)}
                heading={selectedElement?.task?.name}
            >
                {selectedElement && (
                    <AddForm
                        studentId={studentId}
                        patientProgramId={patientProgramId}
                        patientProgramElement={selectedElement}
                        onClose={() => setSelectedElement(null)}
                    />
                )}
            </VimoModal>
        </div>
    );
};

FormList.propTypes = {
    studentId: PropTypes.string.isRequired,
    patientProgramId: PropTypes.string,
};

FormList.defaultProps = {
    patientProgramId: null,
};

export default FormList;
